<div class="vc-field">
   <label
      *ngIf="label"
      class="vc-label">
      {{ label }}
      <span
         *ngIf="required"
         class="required-asterisk">
         *
      </span>
   </label>
   <div [ngClass]="sizeClass">
      <p-dropdown
         #dropdown
         [styleClass]="variantClass"
         inputId="itemSelect"
         [options]="_items"
         [optionLabel]="optionLabel"
         [optionValue]="optionValue"
         [placeholder]="placeholder"
         [disabled]="disabled"
         [filter]="filter"
         [required]="required"
         [filterBy]="filterBy"
         [filterPlaceholder]="filterPlaceholder"
         [optionDisabled]="isOptionDisabled"
         [showClear]="showClear"
         [(ngModel)]="selectedItem"
         (onChange)="onChange()"
         #ngModelCtrl="ngModel"
         [class.invalid]="required && ngModelCtrl.invalid && (ngModelCtrl.touched || ngModelCtrl.dirty)"></p-dropdown>
   </div>
</div>
